"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUserAgentFromABot = void 0;
var _constants = require("./constants");
var isUserAgentFromABot = exports.isUserAgentFromABot = function isUserAgentFromABot(userAgent) {
  if (!userAgent) {
    return false;
  }
  var regex = new RegExp(_constants.botUserAgents.join('|'), 'i');
  return regex.exec(userAgent) !== null;
};